import React, { useState, useEffect, useRef } from "react";
import Header from "./components/Header";
import Rrss from "./components/Rrss";
import Botones from "./components/Botones";
import Apuntes from "./components/Apuntes";
import Calculadoras from "./components/Calculadoras";
import Juegos from "./components/Juegos";
import EmailSender from "./components/EmailSender"; // Importar el nuevo componente

import "./index.css";

export default function App() {
  const [route, setRoute] = useState("home");
  const isPopNavigation = useRef(false);

  // Initialize history and listen for back/forward (popstate).
  useEffect(() => {
    const onPop = (event) => {
      // Mark that this navigation comes from popstate to avoid pushing a new state.
      isPopNavigation.current = true;
      const state = event.state;
      if (state && state.route) {
        setRoute(state.route);
      } else {
        // Fallback: go to home if no state present
        setRoute("home");
      }
    };

    window.addEventListener("popstate", onPop);

    // Ensure there's an initial history state so back button stays within app.
    // Use replaceState to avoid adding an extra entry immediately.
    try {
      const initialRoute = window.location.hash ? window.location.hash.replace('#', '') : route;
      window.history.replaceState({ route: initialRoute }, "", window.location.pathname + "#" + initialRoute);
      setRoute(initialRoute);
    } catch (e) {
      // ignore
    }

    return () => window.removeEventListener("popstate", onPop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Push a new history entry when route changes (unless it was caused by popstate).
  useEffect(() => {
    if (isPopNavigation.current) {
      // reset flag and don't push — this navigation came from the browser back/forward
      isPopNavigation.current = false;
      return;
    }
    try {
      window.history.pushState({ route }, "", window.location.pathname + "#" + route);
    } catch (e) {
      // ignore
    }
  }, [route]);
  return (
    <>
      <div className="page">
        <div className="container">
          <Header setRoute={setRoute} />
          <Rrss />

          {route === "home" && <Botones setRoute={setRoute} />}
          {route === "apuntes" && <Apuntes setRoute={setRoute} />}
          {route === "calculadoras" && <Calculadoras setRoute={setRoute} />}
          {route === "juegos" && <Juegos setRoute={setRoute} />}
          {route === "enviar-correo" && <EmailSender setRoute={setRoute} />} {/* Nueva ruta para Enviar Correo */}
        </div>
      </div>
    </>
  );
}
